// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1332":"cd5c59072edc4150","2370":"b511c649100952c8","6134":"713bef630d9f37db"}[chunkId] + ".css";
};